import mermaid from 'mermaid';
import { useEffect, useRef } from 'react';

mermaid.initialize({ startOnLoad: false, theme: 'default' });

export function MermaidDiagram({ code }: { code: string }) {
    const containerRef = useRef<HTMLDivElement>(null);
    const idRef = useRef(`mermaid-${crypto.randomUUID()}`);

    useEffect(() => {
        let active = true;

        mermaid.render(idRef.current, code).then(({ svg }) => {
            if (active && containerRef.current) {
                containerRef.current.innerHTML = svg;
            }
        });

        return () => {
            active = false;
        };
    }, [code]);

    return <div ref={containerRef} />;
}
